// ExpenseType Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get expenseTypeList from backend then update expenseTypeList in vuex store ***** //
export const updateExpenseTypeList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('expense_types_index', { params: params })
    commit('updateExpenseTypeList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch ExpenseType from backend ***** //
export const fetchExpenseTypeInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`expense_types_show/${payload}`)
    commit('fetchExpenseTypeInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add ExpenseType  ***** //
export const addExpenseType = async (ignored, payload = null) => {
  try {
    await Axios.post('expense_types_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update ExpenseType  info ***** //
export const updateExpenseTypeInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`expense_types_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete ExpenseType  ***** //
export const deleteExpenseType = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`expense_types_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullExpenseTypesList = async ({ commit }) => {
  let expenseTypesList = []

  try {
    const result = await Axios.get('expense_types_list')
    result.data.data.forEach(expenseType => {
      expenseTypesList.push({
        value: expenseType.expense_type_id,
        text: expenseType.expense_name
      })
    })
    commit('setFullExpenseTypesList', expenseTypesList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
